import { render, staticRenderFns } from "./OfficeView.vue?vue&type=template&id=453d6ad9&scoped=true"
import script from "./OfficeView.vue?vue&type=script&lang=js"
export * from "./OfficeView.vue?vue&type=script&lang=js"
import style0 from "./OfficeView.vue?vue&type=style&index=0&id=453d6ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d6ad9",
  null
  
)

export default component.exports